// src/admin/pages/Dashboard/AdminDashboard.js
import React from "react";

export default function AdminDashboard() {
  return (
    <div>
      <h1>Inventory Dashboard</h1>
      <p>Prossimamente integreremo altri elementi qui...</p>
    </div>
  );
}
